import React, { useEffect, useState } from 'react';
import { ignite } from '@ignitesales/neuro-application';
import ActionService from '@ignitesales/neuro-application/src/neuro-guide/services/ActionService.mjs';

const ActionInput = ({ actionInput, disabled, answer }) => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const { name, type, message, options, value, isTextArea } = actionInput;
  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);


  const onChange = (targetValueKey = 'value') => (e) => {
    const newValue = e.target[targetValueKey];
    setInputValue(newValue);
    actionInput.value = newValue;

    if (actionInput.saveTo == 'answers') {
      ignite.answerService.saveAnswer({
        appkey: actionInput.name,
        value: actionInput.value,
        timestamp: new Date()
      }).then();
    } else if (actionInput.saveTo == 'session') {
      ActionService.saveActionMetadata(actionInput.name, actionInput.value);
    }
  }

  useEffect(() => {
    setDisableSubmit(disabled || false)
  }, [disabled]);

  // Function to render different types of input elements based on the type
  const renderInput = () => {
    // Handle textarea variant for text type
    if (type === 'text' && isTextArea) {
      return (
        <textarea
          name={name}
          value={inputValue}
          disabled={disableSubmit}
          onChange={onChange()}
          rows={4}
        />
      );
    }

    switch (type) {
      case 'text':
        return (
          <input
            type="text"
            name={name}
            value={inputValue}
            disabled={disableSubmit}
            onChange={onChange()}
          />
        );
      case 'number':
        return (
          <input
            type="number"
            name={name}
            value={inputValue}
            disabled={disableSubmit}
            onChange={onChange()}
          />
        );
      case 'dropdown':
        return (
          <select
            name={name}
            value={inputValue}
            disabled={disableSubmit}
            onChange={onChange()}
          >
            {options.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );
      case 'checkbox':
        return (
          <input
            type="checkbox"
            name={name}
            checked={!!inputValue}
            onChange={onChange('checked')}
          />
        );
      default:
        return <p>Unsupported input type</p>;
    }
  };

  return (
    <div className="action-input-container">
      <div className="action-input-message">
        {actionInput.message}
      </div>
      <div className="action-input">
        {renderInput()}
      </div>
    </div>
  );
};

export default ActionInput;
export { ActionInput };
